import { PanelTop, Flower2, Rows3, Layers, PanelBottom, LayoutGrid, Box, Lightbulb, Wrench, Columns3 } from "lucide-react";

export const CATALOG_CATS = [
  { slug: "corniches", Icon: PanelTop, image: "/works/photos/photo_1.jpg" },
  { slug: "rosaces", Icon: Flower2, image: "/works/photos/photo_6.jpg" },
  { slug: "moldings", Icon: Rows3, image: "/works/photos/photo_18.jpg" },
  { slug: "colonnes", Icon: Columns3, image: "/works/photos/photo_9.jpg" },
  { slug: "wallpaper", Icon: Layers, image: "/works/photos/photo_35.jpg" },
  { slug: "skirtings", Icon: PanelBottom, image: "/works/photos/photo_24.jpg" },
  { slug: "cladding", Icon: LayoutGrid, image: "/works/photos/photo_31.jpg" },
  { slug: "panels3d", Icon: Box, image: "/works/photos/photo_20.jpg" },
  { slug: "lighting", Icon: Lightbulb, image: "/works/photos/photo_12.jpg" },
  { slug: "technical", Icon: Wrench, image: "/works/photos/photo_25.jpg" },
];

export const CATALOG_SLUGS = CATALOG_CATS.map((c) => c.slug);
